// extracted by mini-css-extract-plugin
module.exports = {"tableBody":"_ebb6397"};